// import modernizr from 'modernizr';

import "jquery";
import WebFont from 'webfontloader';
import imagesLoaded from 'imagesloaded';
import MobileDetect from 'mobile-detect';
import { Swiper } from "swiper";
import 'swiper/css';
import Lenis from 'lenis'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import objectFitImages from 'object-fit-images';
import Scrollbar from 'smooth-scrollbar';
import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll';
import LazyLoad from "vanilla-lazyload";
import { EffectFade, Navigation, Autoplay, FreeMode, Zoom } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/zoom';
import 'swiper/css/pagination';
import { initScrollAnimation } from "./animation";

Scrollbar.use(OverscrollPlugin);
Swiper.use([EffectFade, Navigation, Autoplay, FreeMode, Zoom]);
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const md = new MobileDetect(window.navigator.userAgent);

// iOS 13 からiPadはデフォルトMac扱いのため
function isIpad() {
  const ua = window.navigator.userAgent.toLowerCase();
  if(ua.indexOf('ipad') > -1
    || ua.indexOf('macintosh') > -1 && 'ontouchend' in document){
    // iPad用の処理
    return true;
  }
  return false;
}
export function isMobileDevice() {
  return md.mobile() || isIpad() || md.os() === "AndroidOS";
}
export function isMobileWidth() {
  const mql = window.matchMedia('screen and (min-width: 900px)');
  return !mql.matches;
}

// const lenis = new Lenis();
// function raf(time) {
//   lenis.raf(time);
//   requestAnimationFrame(raf);
// }
// requestAnimationFrame(raf);
const lenis = new Lenis();
lenis.on('scroll', (e) => {
  // console.log(e)
})
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time)=>{
  lenis.raf(time * 1000)
});

gsap.ticker.lagSmoothing(0);

( function( $ ) {

  // WebFont.load(
  //   {
  //     custom:
  //       {
  //         families: ['recoletamedium']
  //       },
  //   });

  let scrollbarWidth = 0;

  if (isMobileDevice()) {
    $('body').addClass('mobile');
  }

  const isIE = /(trident|msie)/i.test( navigator.userAgent );
  if (isIE) {
    $('body').addClass("ie");
  }

  const isWindows = () => {
    return navigator.platform.indexOf('Win') > -1
  }
  if (isWindows() && !isMobileDevice()) {
    $('html').addClass("windowsDesktop");
  }

  function adjustViewHeight() {
    let vh = document.documentElement.clientHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  adjustViewHeight();

  $.fn.hasAnyClass = function() {
    for (const i = 0; i < arguments.length; i++) {
      if (this.hasClass(arguments[i])) {
        return true;
      }
    }
    return false;
  }

  const waitForFinalEvent = (function () {
    const timers = {};
    return function (callback, ms, uniqueId) {
      if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
      if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
      timers[uniqueId] = setTimeout(callback, ms);
    };
  })();

  const preventEvent = function( e ){
    e.preventDefault();
    e.stopPropagation();
  }

  let bodyScrollTop = 0;

  function disableScroll(selector) {
    lenis.stop();
    // const $html = $("html");
    // const htmlHeight = $html.height();
    // bodyScrollTop = $(window).scrollTop();
    //
    // $('html, body').addClass('no-scroll'); // 判定のため必須
    //
    // Object.assign(document.body.style, {
    //   height: htmlHeight,
    //   width: "100%",
    //   position: "fixed",
    //   top: `-${bodyScrollTop}px`,
    //   // overflow: "hidden",
    //   paddingRight: `${scrollbarWidth}px`,
    // });
    //
    // // if (!selector || document.querySelector(selector).scrollHeight <= window.innerHeight) {
    // //   window.addEventListener('touchmove', preventEvent, {passive: false});
    // // }

    // adjust positions
    $("html").css("padding-right", scrollbarWidth);
    // $(".header .sns-links").css("right", scrollbarWidth + "px");
    $("#header").css("padding-right", scrollbarWidth + "px");
    $("#header .btn-release").css("right", scrollbarWidth + "px");
    $("#header .language-switcher").css("padding-right", scrollbarWidth + "px");
  }

  function enableScroll() {
    lenis.start();
    // const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
    // // window.removeEventListener( 'touchmove' , preventEvent, { passive: true } );
    //
    // $('html, body').removeClass('no-scroll');
    //
    // Object.assign(document.body.style, {
    //   height: "",
    //   width: "",
    //   position: "",
    //   top: "",
    //   overflow: "auto", // or auto
    //   paddingRight: "",
    // });
    // if (bodyScrollTop) {
    //   scrollElement.scrollTop = bodyScrollTop;
    // }
    // bodyScrollTop = 0;

    $("html").css("padding-right", "");
    // // $(".header .sns-links").css("right", 0);
    $("#header").css("padding-right", 0);
    $("#header .btn-release").css("right", 0);
    $("#header .language-switcher").css("padding-right", "");
  }

  function isMobileOS() {
    return $('body').hasClass("mobile");
  }

  function isNoScroll() {
    return $('body').hasClass("no-scroll");
  }

  $(function() {

    objectFitImages();

    const lazyLoadInstance = new LazyLoad({
      // Your custom settings go here
    });

    // Create the measurement node
    const scrollDiv = document.createElement("div");
    scrollDiv.className = "scrollbar-measure";
    document.body.appendChild(scrollDiv);

    // Get the scrollbar width
    scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    // console.warn(scrollbarWidth); // Mac:  15

    // Delete the DIV
    document.body.removeChild(scrollDiv);

    const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

    jQuery('.pgscrl').click(function () {
      const speed = 1;
      const href = $(this).attr("href");
      const target = $(href === "#" || href === "" ? 'html' : href);
      const position = target.offset().top;

      gsap.to(scrollElement, {
        duration: speed,
        scrollTo: {y: position, autoKill: false},
        ease: "power2.inOut",
      });

      return false;
    });


    function fadeLoadingBlock() {
      clearTimeout(loadingGuardTimer);
      $('body').addClass('transitioned');
      adjustViewHeight();
      const event = new CustomEvent('onLoadingFade');
      window.dispatchEvent(event);
      if ($('body').hasClass('home')) {
        setTimeout(() => {
          initScrollAnimation();
        }, 1000);
      }
      gsap.to("#loading",
        {
          duration: 1600 / 1000,
          ease: "power2.inOut",
          opacity: 0,
          onComplete: function() {
            setTimeout(function() {
              $(window).trigger('onLoadingHide');
              $('#loading').hide();
              // enableScroll();
            }, 10);
          },
        });
    }

    function checkFontLoading() {
      if ($("html").hasClass('wf-loading')) {
        setTimeout(checkFontLoading, 200);
      } else {
        setTimeout(fadeLoadingBlock, 200);
      }
    }

    // 読み込み完了できなかったときのガード処理
    const loadingGuardTimer = setTimeout(function () {
      fadeLoadingBlock();
    }, 5000);

    // disableScroll();
    imagesLoaded(document.querySelector('body'), function (instance) {
      checkFontLoading();
    });

    let nowMobileWidth = isMobileWidth();
    $(window).resize(function() {
      // menuViewPs.update();
      const newMobileWidth = isMobileWidth();
      if (nowMobileWidth !== newMobileWidth) {
        setStdScrollBlock();
        nowMobileWidth = newMobileWidth;
      } else {
        stdScrollBlock.map(scrollBar => {
          scrollBar.update();
        });
      }
      adjustViewHeight();
    });

    const scrollBars = [];
    $('.scrollbox').each(function(){
      const ps = Scrollbar.init($(this)[0], {
        alwaysShowTracks: true,
        continuousScrolling: false,
        damping: 0.1,
        plugins: {
          overscroll: {
            damping: 0.2,
            maxOverscroll: 50,
          },
        },
      });
      scrollBars.push(ps);
    });

    let stdScrollBlock = [];
    function setStdScrollBlock() {
      stdScrollBlock.map(scrollBar => {
        scrollBar.destroy();
      });
      stdScrollBlock = []
      if (!isMobileWidth()) {
        $('.std-scroll-block').each(function(){
          const ps = Scrollbar.init($(this)[0], {
            alwaysShowTracks: true,
            continuousScrolling: false,
            damping: 0.1,
            plugins: {
              overscroll: {
                damping: 0.2,
                maxOverscroll: 50,
              },
            },
          });
          stdScrollBlock.push(ps);
        });
      }
    }
    setStdScrollBlock();

    if ($('body').hasClass('photo-gallery')) {
      if ($('.collection-slider')[0]) {
        // document.getElementById('page').appendChild(document.getElementById('collection-view'));

        const swiper = new Swiper('.collection-slider', {
          // Optional parameters
          loop: true,
          speed: 300,
          init: false,
          zoom: {
            maxRatio: 2,
          },
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 2,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          passiveListeners: false,
        });
        swiper.on('init', function () {
          // gsap.to('.swiper-slide', 2, {
          //   opacity: 1,
          //   ease: Power2.easeOut,
          // });
        });
        swiper.init();

        function showCollectionView(sliderPos) {
          disableScroll();
          $('#collection-view').show();
          // console.log(sliderPos);
          swiper.slideTo(sliderPos, 0);
          swiper.update();
          gsap.to("#collection-view",
            {
              duration: 0.6,
              opacity: 1,
              ease: "power2.inOut",
              onComplete: function() {
              },
            }
          );
        }
        function hideCollectionView() {
          gsap.to("#collection-view",
            {
              duration: 0.6,
              opacity: 0,
              ease: "power2.inOut",
              onComplete: function() {
                $('#collection-view').hide();
                enableScroll();
              },
            }
          );
        }
        $('.collection-list-item').click(function() {
          const sliderPos = $(this).data("slider-pos");
          showCollectionView(sliderPos);
        });
        $('#collection-view .close-button').click(function() {
          hideCollectionView();
        });
      }
    }


    const $view = $('#menu-view');
    const menuDuration = 800;

    function resetMenuViewAnimation() {
      const $view = $('#menu-view');
      // gsap.to($view.find('.anm-up'), 0,
      //   {
      //     opacity: 0,
      //   });
      // $view.css("overflow", "");
    }
    // resetMenuViewAnimation();

    // const menuViewPs = Scrollbar.init(document.querySelector('#menu-view-inner'), {
    //   alwaysShowTracks: true,
    //   continuousScrolling: false,
    //   damping: 0.1,
    //   plugins: {
    //     overscroll: {
    //       damping: 0.2,
    //       maxOverscroll: 50,
    //     },
    //   },
    // });

    function showSideMenu() {
      $view.show();

      // menuViewPs.update();
    }

    function hideSideMenu() {
      $view.hide();
    }

    $(document).on("click", ".toggle-button", function(e) {
      e.preventDefault();
      showSideMenu();
      gsap.fromTo($view,
        {
          duration: menuDuration / 1000,
          opacity: 0,
        },
        {
          duration: menuDuration / 1000,
          ease: "power2.inOut",
          opacity: 1,
          // onComplete: function() {
          //   animateUp($view, 0);
          // },
        });
      disableScroll('#menu-view-inner');

      return false;
    });

    /* menu-view closebutton */
    $(document).on("click", "#menu-view .close-button", function(e) {
      e.preventDefault();
      gsap.to($view,
        {
          duration: menuDuration / 1000,
          ease: "power2.inOut",
          opacity: 0,
          delay: 0.1,
          onComplete: function() {
            hideSideMenu();
            resetMenuViewAnimation();
            enableScroll();
          },
        });
      $view.css("overflow", "hidden");
      return false;
    });
    $(document).on("click", "#menu-view a:not(.close-button)", function(e) {
      // console.log(this.hash);
      // console.log(this.pathname);
      // console.log(window.location.pathname);
      if(this.pathname === window.location.pathname && this.hash){
        e.preventDefault();
        enableScroll();
        // if (locoScroll) {
        //   locoScroll.scrollTo(this.hash);
        // } else {
        gsap.to(window, {
          duration: 1,
          scrollTo: this.hash,
        })
        // }
      }
      gsap.to($view,
        {
          duration: menuDuration / 1000,
          ease: "power2.inOut",
          opacity: 0,
          delay: 0.1,
          onComplete: function() {
            hideSideMenu();
            resetMenuViewAnimation();
            enableScroll();
          },
        });
    });

    // let ticking = false;
    // const handleScroll = () => {
    //   if (!ticking) {
    //     requestAnimationFrame(function () {
    //       ticking = false;
    //
    //     });
    //     ticking = true;
    //   }
    // }
    // document.addEventListener("scroll", handleScroll, { passive: true });

    window.addEventListener("pageshow", function(event){
      if (event.persisted) {
        // ここにキャッシュ有効時の処理を書く
        $('body').removeClass('transition');
        $('#page').removeClass('transition');
        hideSideMenu();
        resetMenuViewAnimation();
        enableScroll();
      }
    });

  });

} )( jQuery );
